// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","salamlogo":"salamlogo__AUzZy","logoWrapper":"logoWrapper__LRnOO","login":"login__tfmQr"};